import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@base/environments/environment';
import { UtilsService } from '../../../services/utils.service';
import { LogedUser } from '../../models/logged-user.model';

@Injectable()
export class LegacyJwtInterceptor implements HttpInterceptor {
  constructor(private readonly utils: UtilsService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const CURRENT_USER: LogedUser | undefined = this.utils.getLoggedUser();
    const IS_OLD_ENVIRONMENT = !environment.apiEndpoint.includes('proxy');
    const IS_URL_OLD = request.url.includes(environment.oldFrontUrl);

    if (
      CURRENT_USER &&
      CURRENT_USER.secret &&
      !IS_URL_OLD &&
      !IS_OLD_ENVIRONMENT &&
      this.isConfiguredProxyUrl(request.url)
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${CURRENT_USER.secret}`,
        },
      });
    }

    if (IS_URL_OLD || IS_OLD_ENVIRONMENT) {
      request = request.clone({ withCredentials: true });
    }

    return next.handle(request);
  }

  private isConfiguredProxyUrl(url: string): boolean {
    const PROXY_PREFIX = String(environment.apiEndpoint || '');
    if (!PROXY_PREFIX) {
      return false;
    }
    if (url.startsWith(PROXY_PREFIX)) {
      return true;
    }
    try {
      const PROXY_ORIGIN = new URL(PROXY_PREFIX).origin;
      return Boolean(PROXY_ORIGIN) && url.startsWith(PROXY_ORIGIN);
    } catch {
      return false;
    }
  }
}
